import {
  LayoutDashboard,
  Truck,
  CalendarDays,
  Users,
  HardHat,
  Wrench,
  Wallet,
  Clock,
  AlertTriangle,
  ScrollText,
  BarChart3,
  Radio,
  ClipboardList,
  ClipboardCheck,
  Banknote,
  Inbox,
} from 'lucide-react';

export const NAV_ICONS = {
  overview: LayoutDashboard,
  machines: Truck,
  bookings: CalendarDays,
  clients: Users,
  owners: HardHat,
  operators: Wrench,
  wallet: Wallet,
  approvals: Clock,
  dlq: AlertTriangle,
  audit: ScrollText,
  reports: BarChart3,
  surveys: ClipboardList,
  surveyReview: ClipboardCheck,
  surveyPayout: Banknote,
  surveyQr: Users,
  iot: Radio,
  grievances: Inbox,
};
